import { useAuth } from "@/hooks/useAuth";
import { useLifeMart } from "@/hooks/useLifeMart";

/**
 * Full tool access after the employer-only pivot.
 * New accounts can only be created through employer company-code pages or
 * LifeMart, so any signed-in member (including pre-pivot members, who keep
 * their access) or verified LifeMart visitor has full access.
 */
export function hasFullAccess(opts: { signedIn: boolean; lifeMartVerified: boolean }): boolean {
  return opts.signedIn || opts.lifeMartVerified;
}

export function useEmployerAccess() {
  const { user, loading } = useAuth();
  const { isLifeMartMember } = useLifeMart();
  return { loading, hasAccess: hasFullAccess({ signedIn: !!user, lifeMartVerified: !!isLifeMartMember }) };
}
